<template>
  <div>
    <section v-if="hasSubscriber" class="b-tooltips">
      <b-tooltip
        v-for="license in data"
        :key="license.type"
        :position="tooltipPos"
        type="is-gold is-light"
        multilined
      >
        <div class="is-flex is-flex-direction-column is-justify-content-center">
          <b-tag :type="color[license.type]">{{ license.type }}</b-tag>
          <p class="has-text-centered">{{ "x" + license.count }}</p>
        </div>
        <template v-slot:content style="border: 1px solid green">
          <div class="has-text-left">
            <p><strong>Abonnenten:</strong></p>
            <ul
              v-if="license.orgs.length"
              style="list-style: initial; margin-left: 1rem"
              class="mt-1"
            >
              <li v-for="org in license.orgs" :key="org">{{ org }}</li>
            </ul>
            <div v-else>-</div>
          </div>
        </template>
      </b-tooltip>
    </section>
  </div>
</template>

<script>
export default {
  name: 'OrgLicenseCounter',
  props: {
    data: {
      type: Object,
      required: false,
      default: () => {},
    },
    tooltipPos: {
      type: String,
      default: 'is-top',
    },
  },
  data() {
    return {
      color: {
        Haupt: 'is-gold',
        Unter: 'is-grey-1',
        Test: 'is-grey-2',
      },
    };
  },
  computed: {
    hasSubscriber() {
      return this.data.main.count || this.data.sub.count || this.data.test.count;
    },
  },
};
</script>
